// src/plugins/pinia.js
import { createPinia } from 'pinia';

const pinia = createPinia();

export default pinia;
